const argentinaContent = {
  preview: `The Liga Profesional Argentina 2025 continues to captivate football fans worldwide, 
  partly due to the Messi effect raising global interest in Argentine football following the 2022 
  World Cup triumph. Boca Juniors and River Plate's Superclasico remains one of world football's 
  most intense rivalries, while Racing Club and San Lorenzo provide consistent competition at the top.`,

  keyStories: [
    {
      title: "Post-World Cup Boom",
      desc: "Argentine football enjoys unprecedented global attention following the national team's World Cup triumph, boosting Liga Profesional viewership worldwide."
    },
    {
      title: "Superclasico — Boca vs River",
      desc: "The world's most passionate derby continues to define Argentine football seasons, with both clubs investing to dominate domestically."
    },
  ],

  titleContenders: ["River Plate", "Boca Juniors", "Racing Club", "San Lorenzo", "Independiente"],

  fullPreview: `
    <h3>Liga Profesional Argentina 2025 — Complete Analysis</h3>
    <p>Argentine football operates on a unique calendar with Apertura and Clausura tournaments 
    providing two title opportunities per year. This format keeps competition intense throughout 
    the year and gives more clubs realistic opportunities for silverware.</p>
    
    <h3>PitchFacts Prediction</h3>
    <p>River Plate and Boca Juniors remain the two most likely title winners across both 
    tournament phases, though Racing Club have shown the consistency to challenge.</p>
  `,
};

export default argentinaContent;